import { UAParser } from 'ua-parser-js';
import { Devices } from '../store/modules/header-module';
export const getUserAgentData = (userAgent) => {
  const { device, browser, os } = UAParser(userAgent);
  return {
    device: device.type === 'mobile' ? Devices.mobile : device.type === 'tablet' ? Devices.tablet : Devices.desktop,
    os: os.name,
    // Google Search App for iOS (browser) will cover any element fixed to
    // the bottom of the screen with its goofy nav bar. Scrolling also seems
    // to confuse the browser with maths. This fix ensures that the Footer
    // always remains visible.
    isGSAoniOS: os.name === 'iOS' && browser.name === 'GSA',
  };
};
